var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cost-round-svgrepo-com",
    d: "M50.583,27.366a25,25,0,1,1-25-25,25,25,0,0,1,25,25ZM35.287,32.9a7.1,7.1,0,0,0-1.756-4.664l0-.006a9.536,9.536,0,0,0-2.637-2.1l-.009-.006a11.046,11.046,0,0,0-2.735-.988h-.006a11.936,11.936,0,0,0-2.51-.262,9,9,0,0,1-1.5-.117,5.684,5.684,0,0,1-1.56-.5l-.006,0a3.7,3.7,0,0,1-1.172-.941l0,0a2.315,2.315,0,0,1-.553-1.389,2.365,2.365,0,0,1,1.329-1.989A6.811,6.811,0,0,1,25.671,19a7.209,7.209,0,0,1,1.235.208l.155.032a7.828,7.828,0,0,1,1.494.524,4.2,4.2,0,0,1,1.2.824,2.5,2.5,0,1,0,3.53-3.537A9.164,9.164,0,0,0,30.6,15.2a12.619,12.619,0,0,0-2.479-.846h0L28.1,14.35V11.868a2.5,2.5,0,1,0-5,0v2.409a11.232,11.232,0,0,0-3.6,1.434,7.351,7.351,0,0,0-3.66,6.211,7.25,7.25,0,0,0,1.67,4.547,8.6,8.6,0,0,0,2.823,2.264,10.553,10.553,0,0,0,2.975.963,13.888,13.888,0,0,0,2.324.186,6.953,6.953,0,0,1,1.453.145,6.085,6.085,0,0,1,1.475.531,4.519,4.519,0,0,1,1.206.973,2.128,2.128,0,0,1,.521,1.377c0,.306,0,1.023-1.216,1.809a6.89,6.89,0,0,1-3.575.992,11.1,11.1,0,0,1-1.56-.189,7.519,7.519,0,0,1-1.449-.467h0a3.009,3.009,0,0,1-1.124-.865,2.5,2.5,0,1,0-3.78,3.275A7.945,7.945,0,0,0,20.632,39.7a12,12,0,0,0,2.444.748H23.1v2.473a2.5,2.5,0,1,0,5,0V40.423a11.308,11.308,0,0,0,3.695-1.513,6.994,6.994,0,0,0,3.5-6Z",
    transform: "translate(-0.583 -2.366)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCost);
export default __webpack_public_path__ + "static/media/icon-cost.1ff0ffb42832a4972ed0a56229e89ba6.svg";
export { ForwardRef as ReactComponent };